export default "__VITE_ASSET__BoFVqqpc__"